import Vue from 'vue';
import App from './App';
import routes from './router';
import Router from 'vue-router';
import {get,post,post_API_UP} from '../store/vue_resource';
import {hasBtn,getBtnStatus,removeByIndex,getTime,getTime_us,getTime_us_us,getTime_zone,isMobile,getTime_week,week_f,unique1,price_discount,parseTime,detectZoom} from '../store/store';

// import Swiper from 'swiper';
// import 'swiper/css/swiper.css';

if (isMobile()) {
	import("@/assets/css/wapstyle.css");
	import("@/assets/js/font.js");
}else{
	import("@/assets/css/style.css");
	detectZoom();
}

// import("@/assets/css/style.css");



import ElementUI from 'element-ui';
import GeminiScrollbar from 'vue-gemini-scrollbar';
import 'element-ui/lib/theme-chalk/index.css';
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
import VueResource from 'vue-resource';
import { Loading } from 'element-ui';
Vue.component(CollapseTransition.name, CollapseTransition);
Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.$post_API_UP = post_API_UP;
Vue.prototype.$getBtnStatus = getBtnStatus;
Vue.prototype.hasBtn = hasBtn;
Vue.prototype.removeByIndex = removeByIndex;
Vue.prototype.getTime = getTime;
Vue.prototype.getTime_us = getTime_us;
Vue.prototype.getTime_us_us = getTime_us_us;
Vue.prototype.getTime_zone = getTime_zone;
Vue.prototype.getTime_week = getTime_week;
Vue.prototype.unique1 = unique1;
Vue.prototype.week_f = week_f;
Vue.prototype.price_discount = price_discount;
Vue.prototype.parseTime = parseTime;
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueResource);

Vue.use(GeminiScrollbar);


// import VueMoment from "moment";
// import moment from "moment-timezone";

// Vue.use(VueMoment, {
// 	moment
// });


import i18n from './i18n/i18n';
var lang = localStorage.getItem('lang') || 'cn';
i18n.locale = lang;
Vue.prototype.lang = lang;

const router = new Router({
  routes
})

router.beforeEach((to, from, next) => {
	var TokenId = localStorage.getItem('TokenId') || '';
	var path_array=['/virtual_batchtask_info'];
	if (to.path == '/login') {
		localStorage.removeItem('TokenId');
		localStorage.removeItem('user_name');
	}else if (!TokenId&&path_array.indexOf(to.path)==-1) {
		next({
			path: '/login?redirect='+to.fullPath
		})
	}
	next();
})
new Vue({
	el: '#app',
	i18n,
	router,
	components: {
		App
	},
	template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js